export default [
    {
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    },
    {
        name: '__slot:backlinks_domain',
        sortField: 'name',
        type: 'string',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: '__slot:outlinks_count',
        sortField: 'outlinks_count',
        type: 'number',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:outlinks_active_count',
        sortField: 'outlinks_active_count',
        type: 'number',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:outlinks_archive_count',
        sortField: 'outlinks_archive_count',
        type: 'number',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:total_backips_count',
        sortField: 'ips',
        type: 'number',
        visibleRule: 'self.viewMode == "all"',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'dr',
        sortField: 'dr',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:total_backdomains_count',
        sortField: 'total_backdomains_count',
        type: 'number',
        visibleRule: 'self.viewMode == "all"',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:total_outdomains_count',
        sortField: 'total_outdomains_count',
        type: 'number',
        visibleRule: 'self.viewMode == "all"',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'vis',
        sortField: 'vis',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'rel_type',
        sortField: 'rel_type',
        type: 'rel_type',
        callback: 'linkRelType',
        defaultValue: () => [],
        defaultSearch: false,
        useInFilter: true,
    },
    {
        // Только в фильтре: IP донора, сюда ведут ссылки из отчётов «Ссылки по IP» и по подсетям
        name: 'source_ip',
        type: 'ip',
        visible: false,
        defaultSearch: false,
        useInFilter: true,
    },
    {
        // Только в фильтре: путь страницы сайта, на которую ведут ссылки (сюда ведут ссылки из пакетного анализа
        // по ссылкам в режиме URL). Корень — /
        name: 'path',
        type: 'string',
        visible: false,
        defaultSearch: false,
        useInFilter: true,
    },
]
